import unauthApiService from './unauthApiService';

export default unauthApiService;
